'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ButtonStyle = require('./ButtonStyle.scss');

var _ButtonStyle2 = _interopRequireDefault(_ButtonStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = (_dec = (0, _reactCssModules2.default)(_ButtonStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ButtonLink, _React$Component);

  function ButtonLink() {
    (0, _classCallCheck3.default)(this, ButtonLink);
    return (0, _possibleConstructorReturn3.default)(this, (ButtonLink.__proto__ || (0, _getPrototypeOf2.default)(ButtonLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(ButtonLink, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        {
          href: this.props.url,
          styleName: 'a-button a-button--' + this.props.weight
        },
        this.props.children
      );
    }
  }]);
  return ButtonLink;
}(_react2.default.Component), _class2.defaultProps = {
  weight: 'primary'
}, _temp)) || _class);
exports.default = ButtonLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/ButtonLink.js
// module id = 2286
// module chunks = 0